import {useTranslation} from "react-i18next"
export default function ProjectTag({tag}) {
    const {t} = useTranslation()
    const tags = {
        "upload": t("Initialized"),
        "lexicons": t("Initialized"),
        "transcription": t("Transcription"),
        "translation": t("Translation"),
        "render": t("Render"),
        "archive": t("Finalized"),
        "finalize": t("Finalized"),
        "finished": t("Exported"),
        "generate_all_ecp": t("Render"),
        "abstract": t("Render"),
        "summary": t("Render"),
        "keypoints": t("Render"),
        "verbatims": t("Render"),
        "glossary": t("Render"),
        "delete": t("Deleted"),
        "public": t("Shared"),
        "private": t("Private"),
    }

    return (
        <>
        <span className={`project-tag ${tag}`}>{tags[tag]}</span>
        </>
    )
}